import { BarChart3 } from "lucide-react";
import { TeamLogo } from "./TeamBits";
import { hotColor } from "./ProbabilityWidget";

const ROWS = [
  ["Gol fatti", "goals_for"], ["Gol subiti", "goals_against"],
  ["Over 1.5", "over_1_5", "%"], ["Over 2.5", "over_2_5", "%"], ["Goal (entrambe)", "btts", "%"],
  ["Corner a favore", "corners_for"], ["Corner contro", "corners_against"],
  ["Tiri totali", "shots"], ["Tiri in porta", "shots_on_target"],
];

const fmt = (v, pct) => (v === null || v === undefined ? "n/d" : pct ? `${v}%` : v);

function Column({ title, block, testId }) {
  return (
    <div className="border border-[#27272A] p-3 min-w-0" data-testid={testId}>
      <div className="label text-[9px] mb-2">{title}{block ? ` · ${block.sample} gare` : ""}</div>
      {block ? ROWS.map(([label, key, pct]) => (
        <div key={key} className="flex items-baseline justify-between gap-2 py-1 border-b border-[#1F1F23] last:border-0">
          <span className="text-[11px] text-[#A1A1AA] truncate">{label}</span>
          <span className="mono font-black text-sm" style={pct ? { color: hotColor(block[key]) } : undefined}>{fmt(block[key], pct)}</span>
        </div>
      )) : <div className="text-xs text-[#71717A]">Dati non disponibili</div>}
    </div>
  );
}

function TeamBlock({ team, analysis, venue, side }) {
  const venueTitle = venue === "home5" ? "Ultime 5 in casa" : "Ultime 5 in trasferta";
  return (
    <div className="space-y-3" data-testid={`team-analysis-${side}`}>
      <div className="flex items-center gap-3">
        <TeamLogo team={team} size={24} />
        <div className="heading text-lg font-black truncate">{team.name}</div>
      </div>
      <div className="grid grid-cols-2 gap-2">
        <Column title="Ultime 10" block={analysis.last10} testId={`team-analysis-${side}-last10`} />
        <Column title={venueTitle} block={analysis[venue]} testId={`team-analysis-${side}-${venue}`} />
      </div>
    </div>
  );
}

export function TeamAnalysis({ match }) {
  const cs = match.corner_stats;
  const h = cs?.home?.analysis;
  const a = cs?.away?.analysis;
  if (!h && !a) return null;
  return (
    <div className="surface-raised p-6 space-y-6" data-testid="team-analysis">
      <div className="label flex items-center gap-2"><BarChart3 size={12} strokeWidth={1.5} /> Analisi squadre · ultime 10 e ultime 5 in casa/fuori</div>
      {h && <TeamBlock team={match.home} analysis={h} venue="home5" side="home" />}
      {a && <TeamBlock team={match.away} analysis={a} venue="away5" side="away" />}
      <div className="text-[10px] text-[#71717A]">Nelle probabilità del modello le ultime 5 in casa (squadra di casa) e in trasferta (ospite) pesano il 60%.</div>
    </div>
  );
}
